import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function TemperatureLabel() {
  return (
    <div className={style.temperatureLabel}>
      <div className={style.temperatureLabel_setTemp}>Set temperature</div>
      <div className={style.temperatureLabel_currentTemp}>
        Current temperature
      </div>
      <h6 className={style.temperatureLabel_degree}>°C</h6>
    </div>
  );
}
